<template>
  <vx-card>
    <div class="w-4/12">
      <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
        <div>
          <ValidationProvider rules="required|min:5|max:10" name="Old Password" v-slot="{ errors }" tag="div">
            <vs-input
              v-validate="'required|min:5|max:10'"
              data-vv-validate-on="blur"
              name="oldPassword"
              icon-no-border
              icon="icon icon-lock"
              icon-pack="feather"
              label-placeholder="Old Password"
              v-model="oldPassword"
              type="password"
              class="w-full"
              ref="oldPassword"
            />
            <span class="text-danger text-sm">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="mt-10">
          <ValidationProvider rules="required|min:5|max:10" name="New Password" vid="newPassword" v-slot="{ errors }" tag="div">
            <vs-input 
              v-model="newPassword" 
              type="password" 
              label-placeholder="New Password" 
              icon-pack="feather"
              icon="icon icon-lock"
              name="newPassword"
              class="w-full"
              ref="newPassowrd"
            />
            <span class="text-danger text-sm">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="mt-10">
          <ValidationProvider rules="required|min:5|max:10|confirmed:newPassword" name="Confirm Password" vid="confirmPassword" v-slot="{ errors }" tag="div">
            <vs-input
              v-model="confirmPassword"
              type="password"
              label-placeholder="Confirm password"
              icon-pack="feather"
              icon="icon icon-lock"
              name="confirmPassword"
              class="w-full"
              ref="confirmPassword"
            />
            <span class="text-danger text-sm">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="mt-10 w-full">
          <vs-button @click="reset" class="w-full">
            Set New Password
          </vs-button>
        </div>

      </ValidationObserver>

    </div>
  </vx-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    ...mapState({
      updateAdminPasswordState: ({ userManagement }) => userManagement.apiState.updateAdminPassword,
    }),
  },
  methods: {
    ...mapActions({
      updateAdminPassword: 'userManagement/updateAdminPassword',
    }),
    async reset() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return this.$vs.dialog({
          color: 'danger',
          title: `Validation Error!`,
          text: 'There is a error in this form',
        });
      }

      const body = {
        currentPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      return this.updateAdminPassword(body);
    },
    clearForm() {
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';

      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
    }
  },
  watch: {
    'updateAdminPasswordState.success'(value) {
      if (value) {
        this.$vs.notify({
          title: 'Successful update!',
          color: 'success',
          position: 'top-center',
        });

        this.clearForm();
      }
    },
    'updateAdminPasswordState.error'(error) {
      if (error) {
        this.$vs.notify({
          title: 'Error!',
          text: error.data.message,
          color: 'danger',
          position: 'top-center',
        });

        this.clearForm();
      }
    },
  },
}

</script>

